<script>
import Header from "./_components/Header.vue";
import Datatable from "./_components/datatable.vue";
import moment from "moment";


export default {
  components: {Header, Datatable},
  data() {
    return {
      title: "Detail Monitoring Salesman",
      baseUrl: "/api/sfa/v1/daily-closing/monitoring-salesman-not-yet-end-session",
      datatable: null,
      header: {
        salesman: "",
        date: "",
        territoryCode: "",
        territoryName: "",
      },
      reason: {
        selected: null,
        options: [],
      },
      modalReason: {
        activeModalReason: false,
      },
      itemSelected: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onClickBtnBack() {
      this.$router.push({ name: "monitoring-salesman" });
    },
    onClickForceEnd(){
      console.log(this.header)
      this.reason = {
        selected: null,
        options: [],
      }
      this.itemSelected = null
      this.getDataReason()
      this.modalReason.activeModalReason = !this.modalReason.activeModalReason
      this.itemSelected = {
        TerritoryID: this.header.territoryID,
        PersonalID: this.header.personalID,
        Date: this.header.date
      }
    },
    getDataReason() {
      this.$vs.loading();
      this.$http
          .get("/api/oms/v1/sfa-master/reason-active", {
            params: {
              order: "code",
              sort: "asc",
              reason_group: "Force End Session",
              is_active: true
            },
          })
          .then((resp) => {
            if (resp.status == "success") {
              this.reason.options = resp.data.records;
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
    },
    onSendApproval(){
      if (!this.reason.selected) {
        return this.$vs.notify({
          title: "Error",
          text: "Please select a reason",
          color: "danger",
          position: "top-right",
        })
      }

      this.$vs.loading()
      this.$http.post(`${this.baseUrl}/force-end-session`, {
        // customer_visit_id: this.itemSelected.CustomerVisitID,
        territory_id: this.itemSelected.TerritoryID,
        reason_id: this.reason.selected.ID,
        reason_text: this.reason.selected.reason,
        personal_id: this.itemSelected.PersonalID,
        date: this.itemSelected.Date,
        // customer_id: this.itemSelected.CustomerID,
      }).then((response) => {
        if(response.code == 200) {
          this.$vs.notify({
            title: "success",
            text: "Success Send Approval Force End Session Salesman",
            color: "success",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
      }).finally(() => {
        this.$vs.loading.close();
      })
    },
    async getData() {
      this.$vs.loading();
      try {
        const response = await this.$http.get(`${this.baseUrl}/show`, {
          params: {
            date: this.$route.query.date,
            personal_id: this.$route.query.personal_id,
            territory_id: this.$route.query.territory_id,
          }
        });

        if(response.code == 200) {
          console.log(response.data)
          this.header.salesman = response.data.salesman;
          this.header.date = moment(response.data.date).format("YYYY-MM-DD");
          this.header.territoryCode = response.data.territory_code;
          this.header.territoryName = response.data.territory_name;
          this.header.personalID = response.data.personal_id;
          this.header.territoryID = response.data.territory_id;
          this.datatable = response.data.records
        }

      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.message,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>


<template>
  <vx-card :title="title">
    <div class="vx-row">
      <div class="vx-col">
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-button class="w-full" color="danger" type="filled" @click="onClickBtnBack">Back</vs-button>
          </div>
        </div>
      </div>
    </div>

    <Header :salesman="header.salesman" :date="header.date" :territory_code="header.territoryCode" :territory_name="header.territoryName" />

    <div class="vx-row">
      <div class="vx-col">
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-button class="w-full" color="primary" v-show="datatable[0].OutTime == '00:00:00'" type="filled" @click="onClickForceEnd">Force End</vs-button>
          </div>
        </div>
      </div>
    </div>

    <vs-prompt
        @accept="onSendApproval"
        :active.sync="modalReason.activeModalReason"
        title="Confirm"
        accept-text="Confirm"
    >
      <div class="con-example-prompt">
        <div>
          <span>Reason</span>
        </div>
        <div>
          <multiselect class="selectExample" v-model="reason.selected" :options="reason.options" label="reason" />
        </div>
      </div>
    </vs-prompt>

    <Datatable :data="datatable" />

  </vx-card>
</template>